import React from 'react';
import styled, { css } from 'styled-components';
import { Shapeable, Event } from '@shapeable/types';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityCard, EntityCardDefaultProps, EntityCardProps } from '@shapeable/ui';
import { EntityCuratorFootMeta } from './entity-curator-foot-meta';
import { VERY_LIGHT_BROWN } from '../../theme';
const cls = classNames('event-curator-card');

// -------- Types -------->

// -------- Props -------->

export type EventCuratorCardProps = EntityCardProps & { 
  entity?: Event;
};

export const EventCuratorCardDefaultProps: Omit<EventCuratorCardProps, 'entity'> = {
  ...EntityCardDefaultProps,
  descriptionMaxLines: 5,
  showDescription: true,
  showTypeHeader: false,
  showDescriptionDivider: false,
};

// -------- Child Component Props -------->

type ContainerProps = {

}

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
  
  `,
});

const FootMetaStyles = breakpoints({
  base: css`
    
  `,
});

// -------- Components -------->

const My = {
  Container: styled(EntityCard)<ContainerProps>`${ContainerStyles}`,
    FootMeta: styled(EntityCuratorFootMeta)`${FootMetaStyles}`,
};

export const EventCuratorCard: Shapeable.FC<EventCuratorCardProps> = (props) => {
  const { className, entity, ...cardProps } = props;

  return (
    <My.Container 
      {...cardProps}
      entity={entity}
      showDescription={true}
      useLink={false}
      showDescriptionDivider={false}
      imageProps={{ showIcon: false }}
      className={cls.name(className)}
      colors={{ background: VERY_LIGHT_BROWN }}
      foot={
        <My.FootMeta entity={entity} />
      }
    />
  )
};

EventCuratorCard.defaultProps = EventCuratorCardDefaultProps;
EventCuratorCard.cls = cls;